export default __webpack_public_path__ + "static/media/igbt.7ee7a7a6.svg";